<template>
  <div class="sp_deviceShare">
    <el-dialog :title="shareMsg.title"
               :visible="shareMsg.show"
               width="30%"
               :before-close="handleClose"
               :close-on-click-modal="false"
               :append-to-body="false">

      <el-form class="share-form"
               :model="shareForm"
               ref="shareForm">
        <div class="share-message">{{shareMsg.message}}</div>
        <el-row>
          <el-col style="height: 56px;position: relative;">
            <div style="margin-bottom:4px;height:20px;lin-height:20px;position: absolute;left:-11px">
              <span class="share-label">Company Name：</span>
            </div>
            <el-select ref="companySelect"
                       v-model="shareForm.companyName"
                       placeholder="Please search the company name"
                       style="width:100%;margin-top:24px"
                       :remote-method="remoteMethod"
                       size="medium"
                       filterable
                       @blur="blurHandler"
                       @change="changeHandler"
                       @focus="focusHandler"
                       remote>
              <el-option v-for="val in channelList"
                         :key="val.channelId"
                         :label="val.channelName"
                         :value="val.channelId"></el-option>
            </el-select>
            <div v-if="showShareMessage"
                 class="rule-message">{{shareMessage}}</div>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer"
            class="dialog-footer">

        <el-button type="primary"
                   @click="handleConfirm('shareForm')"
                   size="medium"
                   :loading="saveLoading">OK</el-button>
        <el-button @click="handleClose"
                   size="medium">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getChannelApi, shareDeviceApi } from '@/api/assetsList.js'
export default {
  name: 'deviceShare',
  props: {
    shareMsg: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      shareForm: {
        companyName: '',
      },
      // shareRules: {
      //   companyName: [
      //     // { required: true, message: 'Please select a partner to share your asset.', trigger: 'blur', }
      //     { required: true, validator: companyRule, trigger: ['change'], }
      //   ]
      // },
      channelList: [],
      saveLoading: false,

      hasSelect: false,
      showShareMessage: false,
      shareMessage: '',
      currentValue: '',
    }
  },

  methods: {
    handleClose() {
      this.$emit('shareChildMsg', { isSave: false })
    },
    handleConfirm(shareForm) {
      const hasSelect = this.channelList.some((item) => {
        return item.channelId === this.shareForm.companyName
      })
      if (!hasSelect) {
        this.showShareMessage = true
        this.shareMessage = 'Please select a partner to share your asset.'
      } else {
        this.saveLoading = true
        let params = {
          channelIdList: [],
          deviceIdList: [],
        }
        params.channelIdList.push(this.shareForm.companyName)
        this.shareMsg.row.forEach((val) => {
          params.deviceIdList.push(val.id)
        })
        shareDeviceApi(params)
          .then((res) => {
            this.saveLoading = false
            this.$message({
              type: 'success',
              message: 'Save successfully',
            })
            this.$emit('shareChildMsg', { isSave: true })
          })
          .catch(() => {
            this.saveLoading = false
          })
      }
    },

    remoteMethod(query) {
      if (query !== '') {
        let params = {
          channelName: query,
        }
        getChannelApi(params).then((res) => {
          if (!res.rows.length) {
            this.$set(this.shareForm, 'companyName', query)
            this.showShareMessage = true
            this.shareMessage =
              'Select an option from the picklist or remove the search term.'
          }
          this.channelList = res.rows
        })
      } else {
        this.channelList = []
      }
    },
    //select远程搜索失焦后保留输入内容
    blurHandler(val) {
      this.currentValue = val.target.value
      this.$nextTick(() => {
        this.$set(this.shareForm, 'companyName', this.currentValue)
        this.showShareMessage = true
        this.shareMessage =
          'Select an option from the picklist or remove the search term.'
      })
    },

    changeHandler() {
      this.showShareMessage = false
    },

    focusHandler() {
      this.channelList = []
      this.shareForm.companyName = ''
    },
  },
  created() {
    console.log(this.shareMsg.row)
  },
}
</script>

<style lang="scss" scoped>
.share-form {
  padding: 16px 20px;
}
.share-message {
  color: #a1a8b3;
  font-size: 14px;
  margin-bottom: 12px;
}
.rule {
  display: inline-block;
  width: 5px;
  margin-top: 1px;
  color: #e65050;
  font-size: 14px;
  margin-right: 4px;
}
.share-label {
  color: #545c66;
  font-size: 14px;
}
.share-label:before {
  content: '* ';
  color: red;
}
.el-dialog__body {
  padding: 0 20px;
}

.rule-message {
  margin-top: 10px;
  font-size: 12px;
  color: #f56c6c;
}
</style>